import { useAuth } from "hooks/useAuth";
import useScreen from "hooks/useScreen";
import { Navigate, Outlet } from "react-router-dom";

export const AuthGuard = () => {
  const { isAuthenticated } = useAuth();

  console.log(isAuthenticated);

  let content;

  if (isAuthenticated) {
    content = <Outlet />;
  } else {
    content = <Navigate to="/login" />;
  }

  return content;
};
